import { Link, useLocation } from 'react-router-dom';
import { Mail, Youtube } from 'lucide-react';

// V2 Theme Colors
const C = {
  white: '#FFFFFF',
  cloud: '#F8FAFC',
  sky: '#0EA5E9',
  ink: '#0F172A',
  slate: '#475569',
  muted: '#94A3B8',
};

const SiteFooterV2 = () => {
  const location = useLocation();
  const isCabinetHome = location.pathname === '/';
  return (
    <footer className="py-16" style={{ backgroundColor: C.white, borderTop: `1px solid ${C.cloud}` }}>
      <div className="max-w-7xl mx-auto px-6 sm:px-12">
        <div className={`grid gap-12 mb-12 ${isCabinetHome ? 'md:grid-cols-2' : 'md:grid-cols-4'}`}>
          {/* Brand */}
          <div className="md:col-span-1">
            <div className="flex items-center gap-3 mb-4">
              <img
                src="https://customer-assets-lqy194kg.emergentagent.net/job_03019b9c-e38d-4235-95ae-da304b949bfe/artifacts/yfyqdasc_Capture%20d%E2%80%99%C3%A9cran%202026-07-19%20092346.png"
                alt="Physiothérapie Les Mains Nuages"
                className="w-16 h-auto object-contain rounded-lg"
              />
              <div>
                <p 
                  className="text-lg font-medium"
                  style={{ fontFamily: 'Outfit, sans-serif', color: C.ink }}
                >
                  Julien Jaccard
                </p>
                <p className="text-xs" style={{ color: C.muted }}>
                  Physiothérapeute
                </p>
              </div>
            </div>
            <p className="text-sm leading-relaxed" style={{ color: C.slate }}>
              Rééducation des troubles respiratoires : hyperventilation, respiration dysfonctionnelle, asthme et COVID Long.
            </p>
          </div>

          {/* Troubles */}
          {/* Troubles + Ressources — masqués sur la page cabinet */}
          {!isCabinetHome && (<>
          <div>
            <h4 
              className="text-sm font-medium uppercase tracking-wider mb-4"
              style={{ color: C.ink }}
            >
              Troubles traités
            </h4>
            <div className="flex flex-col gap-2 text-sm" style={{ color: C.slate }}>
              <Link to="/hyperventilation" className="hover:text-sky-600 transition-colors">Hyperventilation</Link>
              <Link to="/respiration-dysfonctionnelle" className="hover:text-sky-600 transition-colors">Respiration Dysfonctionnelle</Link>
              <Link to="/asthme" className="hover:text-sky-600 transition-colors">Asthme</Link>
              <Link to="/covid-long" className="hover:text-sky-600 transition-colors">COVID Long</Link>
            </div>
          </div>

          {/* Resources */}
          <div>
            <h4 
              className="text-sm font-medium uppercase tracking-wider mb-4"
              style={{ color: C.ink }}
            >
              Ressources
            </h4>
            <div className="flex flex-col gap-2 text-sm" style={{ color: C.slate }}>
              <Link to="/coherence-cardiaque" className="hover:text-sky-600 transition-colors">Cohérence Cardiaque</Link>
              <Link to="/methode-buteyko" className="hover:text-sky-600 transition-colors">Méthode Buteyko</Link>
              <Link to="/evaluer-respiration" className="hover:text-sky-600 transition-colors">Tester sa respiration</Link>
              <Link to="/documents" className="hover:text-sky-600 transition-colors">Documents</Link>
            </div>
          </div>
          </>)}

          {/* Contact */}
          <div>
            <h4 
              className="text-sm font-medium uppercase tracking-wider mb-4"
              style={{ color: C.ink }}
            >
              Contact
            </h4>
            <div className="flex flex-col gap-3 text-sm" style={{ color: C.slate }}>
              <a 
                href="mailto:julienjaccard@mains-nuages.ch" 
                className="flex items-center gap-2 hover:text-sky-600 transition-colors"
                style={{ color: C.sky }}
              >
                <Mail size={16} />
                julienjaccard@mains-nuages.ch
              </a>
              <a 
                href="https://youtube.com/@Jaccardjphysio" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="flex items-center gap-2 hover:text-sky-600 transition-colors"
              >
                <Youtube size={16} />
                @Jaccardjphysio
              </a>
              <p className="mt-2" style={{ color: C.muted }}>
                Valais, Suisse
              </p>
            </div>
            
            {/* QR Code Instagram */}
            <div className="mt-6 flex items-center gap-3">
              <div 
                className="w-20 h-20 rounded-lg shadow-md overflow-hidden"
                style={{ backgroundColor: '#ffffff' }}
              >
                <img 
                  src="https://customer-assets.emergentagent.com/job_03019b9c-e38d-4235-95ae-da304b949bfe/artifacts/msjpp7sf_IMG_6921.JPG"
                  alt="QR Code Instagram - @physiomainsnuages"
                  className="w-full h-full object-contain"
                />
              </div>
              <p className="text-xs" style={{ color: C.muted }}>
                Suivez-moi sur<br />Instagram
              </p>
            </div>
          </div>
        </div>

        {/* Bottom */}
        <div 
          className="pt-8 flex flex-col md:flex-row items-center justify-between gap-4"
          style={{ borderTop: `1px solid ${C.cloud}` }}
        >
          <p className="text-xs" style={{ color: C.muted }}>
            © {new Date().getFullYear()} Julien Jaccard - Les Mains Nuages. Tous droits réservés.
          </p>
          <div className="flex gap-6 text-xs" style={{ color: C.muted }}>
            <Link to="/contact" className="hover:text-sky-600 transition-colors">Contact</Link>
            <Link to="/app-landing" className="hover:text-sky-600 transition-colors">Exercices</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default SiteFooterV2;
